import { useMemo } from 'react';
import type { Impacter } from '../../utils/api/impacter';

type ImpactersDataProps = {
  ids: number[];
  names: string[];
  pairs: { id: number; name: string }[];
};

export const useImpactersData = (impacters?: Pick<Impacter, 'id' | 'externalId' | 'name'>[]) => {
  const { ids, names, pairs } = useMemo(() => {
    return (
      impacters?.reduce(
        ({ ids, names, pairs }: ImpactersDataProps, { id, name }) => {
          ids.push(id);
          names.push(name);
          pairs.push({ id, name });
          return { ids, names, pairs };
        },
        { ids: [], names: [], pairs: [] },
      ) || { ids: [], names: [], pairs: [] }
    );
  }, [impacters]);

  return { impacterIds: ids, impacterNames: names, impacterPairs: pairs };
};
